/* =============================================================================
USB CUSTOM - ENGRAVING
============================================================================= */

window.USB = window.USB || {};

window.USB.Engraving = (() => {
  document.querySelectorAll("[data-usb-engraving]").forEach((wrapper) => {
    const productForm = wrapper
      .closest("[data-product-blocks]")
      ?.querySelector("form[action*='/cart/add']");

    const modal = wrapper.querySelector("[data-usb-engraving-modal]");
    const engravingRadios = wrapper.querySelectorAll('input[name^="usb-engraving-"]');
    const closeButtons = wrapper.querySelectorAll("[data-usb-close-modal]");
    const confirmButton = wrapper.querySelector("[data-usb-confirm-engraving]");
    const input = wrapper.querySelector("[data-usb-engraving-input]");
    const count = wrapper.querySelector("[data-usb-char-count]");
    const preview = wrapper.querySelector("[data-usb-preview-text]");
    const error = wrapper.querySelector("[data-usb-error]");
    const choices = wrapper.querySelectorAll(".usb-engraving__choice");
    const fontRadios = wrapper.querySelectorAll('input[name^="usb-engraving-font-"]');
    const addonVariantId = wrapper.dataset.addonVariantId;

    const state = {
      enabled: false,
      text: "",
      font: "UnifrakturCook"
    };

    function openModal() {
      modal.hidden = false;
      error.hidden = true;
      setTimeout(() => input.focus(), 50);
    }

    function closeModal() {
      modal.hidden = true;

      if (!state.enabled) {
        engravingRadios[0].checked = true;
        engravingRadios[1].checked = false;
        updateChoiceStyle();
      }
    }

    function updateChoiceStyle() {
      choices.forEach((choice) => {
        const radio = choice.querySelector("input");
        choice.classList.toggle("is-active", radio.checked);
      });
    }

    function updatePreview() {
      const value = input.value;

      preview.textContent = value || "Your text";
      count.textContent = value.length;

      preview.style.fontFamily =
        state.font === "Dancing Script"
          ? "'Dancing Script', cursive"
          : "'UnifrakturCook', serif";
    }

    function getQuantity() {
      const quantityInput = productForm?.querySelector("[name='quantity']");
      return quantityInput ? Number(quantityInput.value || 1) : 1;
    }

    function getMainVariantId() {
      const variantInput = productForm?.querySelector("[name='id']");
      return variantInput ? variantInput.value : null;
    }

    function createGroupId() {
      return `engraving-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    }

    function buildItems() {
      const quantity = getQuantity();
      const mainVariantId = getMainVariantId();
      const groupId = createGroupId();

      return [
        {
          id: Number(mainVariantId),
          quantity,
          properties: {
            "_usb_engraving_group": groupId,
            "Personalization": "Engraving",
            "Engraving text": state.text,
            "Font": state.font
          }
        },
        {
          id: Number(addonVariantId),
          quantity,
          properties: {
            "_usb_engraving_group": groupId,
            "_engraving_addon": "true",
            "Engraving text": state.text,
            "Font": state.font
          }
        }
      ];
    }

    async function addEngravedItems(event) {
      if (!state.enabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const items = buildItems();

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({ items })
        });

    document.dispatchEvent(new CustomEvent("cart:build"));
    document.dispatchEvent(new CustomEvent("cart:open"));
    }

    engravingRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateChoiceStyle();

        if (radio.value === "engraving" && radio.checked) {
          openModal();
        }

        if (radio.value === "none" && radio.checked) {
          state.enabled = false;
        }
      });
    });

    fontRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (!radio.checked) return;
        state.font = radio.value;
        updatePreview();
      });
    });

    input.addEventListener("input", () => {
      error.hidden = true;
      updatePreview();
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closeModal);
    });

    confirmButton.addEventListener("click", () => {
      const text = input.value.trim();

      if (!text) {
        error.hidden = false;
        return;
      }

      state.enabled = true;
      state.text = text;

      modal.hidden = true;

      if (productForm && typeof productForm.requestSubmit === "function") {
        productForm.requestSubmit();
      } else if (productForm) {
        productForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      }
    });

    if (productForm) {
      productForm.addEventListener("submit", addEngravedItems, true);
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    updatePreview();
    updateChoiceStyle();
  });
})();